import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/super/user/loadMenus',
    method: 'get',
    params,
  })
}
